export default "__VITE_ASSET__Wh7zxe1o__"